import { render, staticRenderFns } from "./IconQuora.vue?vue&type=template&id=9e1318e6&"
import script from "./IconQuora.vue?vue&type=script&lang=js&"
export * from "./IconQuora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports